/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#buttons-container[_ngcontent-%COMP%]{margin-bottom:10px}[_nghost-%COMP%]{height:100%}#wizard-container[_ngcontent-%COMP%]{height:100%}"];
export { styles as styles };
